export const API_ENDPOINTS = {
    // Users
    userLogin: "/api/organization/userLogin",
    // userLogin: "/api/users/login",
    fetchEmployeesByOrganizationId: (orgId) => `/api/organization/getAllEmployeesByOrganizationId?organization_id=${orgId}`,
    // fetchEmployeesByOrganizationId: (orgId) => `/api/users/getAllEmployeesByOrganizationId?organization_id=${orgId}`,

    generateVerificationOtp: "/api/organization/generateOtp",
    verifyOtp: "/api/organization/verifyOtp",
    resetUserPassword: "/api/organization/updatePassword",
    verifyEmailToken: (token) => `/api/organization/verifyEmail?token=${token}`,
    fetchUserDetails: "/api/organization/getUserDetailsByUserId",
    fetchManagerDashboard: "/api/organization/getDashboardDetailsByManagerId",
    fetchSupervisorProjects: "/api/project/getProjectsBySupervisorId",
    fetchEmployeeProjects: "/api/project/getProjectsByEmployeeId",
    createNewProject: "/api/project/createProject",
    fetchProjectById: (projectId) => `/api/project/getProjectById/${projectId}`,
    updateProject: "/api/project/updateProjectDetails",
    fetchDepartmentsByOrganizationId: "/api/organization/getAllDepartmentsByOrganizationId",
    fetchTeamsByDepartmentId: "/api/organization/getAllTeamsByDepartmentId",
    fetchUsersByTeamId: "/api/organization/getAllUsersByTeamId",
    updateTeamAssignment: "/api/project/updateAssignTeam",
    getAllEpics: "/api/epics/getAllEpics",
    deleteEpic: "/api/epics/epics",
    createProjectEpic: "/api/epics/projects",
    fetchProductOwnersForProject: (projectId) => `/api/epics/projects/${projectId}/product-owners`,
    fetchProjectsBySupervisor: (userId) => `/api/project/getAllProjectsBySupervisor/${userId}`,
    fetchEpicById: (epicId) => `/api/epics/getEpicById/${epicId}`,
    updateEpic: (epicId) => `/api/epics/epics/${epicId}`,
    fetchTeamLeadsForOrganization: (orgId) => `/api/project/getAllTeamLeadOrManager?organization_id=${orgId}&is_team_lead=true`,
    fetchTeamLeadsOrManagers: (orgId, type) =>
        `/api/project/getAllTeamLeadOrManager?organization_id=${orgId}&${type}=true`,
    createTask: "/api/task/createTask",
    getUserStoriesByProjectOrEpic: "/api/userStories/user-stories",
    getSupervisorMainTasks: (managerId) => `/api/task/getAllMainTasksBySupervisorId/${managerId}`,
    fetchAttendanceUnderManager: "/api/organization/getAllEmployeesUnderManagerAttendance",
    getManagerLeaveRequests: "/api/organization/getLeaveRequestsByManager",
    getEmployeeLeaveTypes: (userId) => `/api/organization/getAllLeaveTypesByEmpId?user_id=${userId}`,
    approveLeaveRequest: (leaveId) => `/api/organization/approveLeave/${leaveId}`,
    createLeaveRequest: "/api/organization/createLeave",
    getLeaveInfoByEmployeeId: (userId) => `/api/organization/getAllLeaveTypesByEmpId?user_id=${userId}`,
    fetchLeaveCountsForOrganization: (organizationId) => `/api/organization/getAllLeaveTypes?organization_id=${organizationId}`,
    updateLeaveRequestStatus: (leaveId) => `/api/organization/approveLeave/${leaveId}`,
    savePushSubscription: "/api/notifications/savePushSubscription",
    getEmployeeLeaveBalance: (userId) => `/api/organization/getEmployeeLeaveBalance?user_id=${userId}`,
    getEmployeeLeaveHistory: (userId, year, month, page = 1, limit = 6) =>
        `/api/organization/getLeaveHistoryByEmployee?year=${year}&user_id=${userId}&month=${month}&page=${page}&limit=${limit}`,
    downloadHolidayListPDF: (year, orgId, locId) =>
        `/api/organization/getHolidayListPDF?year=${year}&location_id=${locId}&organization_id=${orgId}`,
    downloadHolidayListExcel: (year, orgId, locId) =>
        `/api/organization/getHolidayListExcel?year=${year}&location_id=${locId}&organization_id=${orgId}`,
    getHolidaysByYearAndMonth: (year, orgId, locId, month) => {
        const base = `/api/organization/getAllHolidaysByYearAndMonth?year=${year}&organization_id=${orgId}&location_id=${locId}`;
        return month ? `${base}&month=${month}` : base;
    },
    getAttendanceByEmployeeAndStatus: (employeeId, month) =>
        `/api/organization/getAttendanceByEmployeeIdByStatus?employee_id=${employeeId}&month=${month}`,
    fetchStoriesByProjectAndEpic: (projectId, epicId = null) => {
        const baseUrl = `/api/userStories/epics/${projectId}/user-stories`;
        return epicId ? `${baseUrl}?epic_id=${epicId}` : baseUrl;
    },
    fetchUserTaskDetails: (id) => `/api/task/getManagerTaskById?task_id=${id}`,
    updateUserTaskById: "/api/task/updateTask",
    deleteUserTaskById: `/api/task/deleteTask`,
    createSubTask: `/api/task/createSubTask`,
    fetchManagerPerformanceDashboardStats: (userId) => `/api/performancemanagement/stats?reporting_manager_id=${userId}`,
    fetchEmployeesByPerformanceStatus: (userId, status) =>
        `/api/performancemanagement/getEmployeesByStatus?status=${status}&reporting_manager_id=${userId}`,
    fetchAppraisalsByStatus: (userId, status, goalPeriod) =>
        `/api/performancemanagement/getAppraisalsByStatus?status=${status}&report_manager_id=${userId}&goal_period=${goalPeriod}`,
    fetchEmployeeDashboardStats: (userId) =>
        `/api/performancemanagement/getEmployeeDashboardStats?reporting_manager_id=${userId}`,
    fetchAppraisalsByManager: (userId, goalPeriod = "Yearly") =>
        `/api/performancemanagement/getAppraisalsByStatus?report_manager_id=${userId}&goal_period=${goalPeriod}`,
    // 65----71
    fetchAppraisalDashboardStats: (userId) =>
        `/api/performancemanagement/getAppraisalDashboardStats?reporting_manager_id=${userId}`,
    fetchEmployeeRatingsAndFeedback: (employeeId, year, period) =>
        `/api/performancemanagement/getRatingsAndFeedback?emp_id=${employeeId}&appraisal_year=${year}&appraisal_period=${period}`,
    fetchAppraisalById: (appraisalId) =>
        `/api/performancemanagement/getAppraisalById?appraisal_id=${appraisalId}`,
    createRatings: "/api/performancemanagement/addRatings",
    fetchEmployeeGoals: (employeeId) => `/api/empGoal/get_All_goals_by_emp_id?emp_id=${employeeId}`,
    fetchGoalById: (goalId) => `/api/empGoal/get_EmpGoal_by_id?id=${goalId}`,
    fetchGoalCommentsById: (goalId) => `/api/empGoal/get_goal_comments_by_id?goal_id=${goalId}`,
    updateGoal: "/api/empGoal/update_EmpGoal",
    addGoalComment: "/api/empGoal/add_goal_comment",
    fetchEmployeeGoalCount: (empId) => `/api/empGoal/total_goal_count?emp_id=${empId}`,
    markAttendance: '/api/organization/markAttendance',
    getTodayAttendanceRecord: (userId) => `/api/organization/getTodayAttendanceRecordForEmployee?user_id=${userId}`,
    updateTodayAttendance: '/api/organization/updateAttendanceByToday',
    fetchHrDashboardData: (organizationId) => `/api/organization/getHrDashboardData?organization_id=${organizationId}`,
    
    fetchDesignationsByTeamId: (teamId) => `/api/organization/getAllDesignationsByTeamId/${teamId}`,
    createUser: "/api/organization/userSignup",
    fetchTeamLeadsAndManagers: (organizationId) => `/api/project/getAllTeamLeadOrManager?organization_id=${organizationId}&is_manager=true&is_team_lead=true`,
    fetchLocationsByOrganizationId: (orgId) => `/api/organization/getAllLocationsByOrgId/${orgId}`,
    fetchRolesByOrganizationId: (organizationId) => `/api/organization/getAllRolesByOrgId?organization_id=${organizationId}`,
    downloadEmployeeListExcel: (organizationId, status, locationId) => `/api/organization/getEmployeeListExcel?organization_id=${organizationId}&status=${status}&location_id=${locationId}`,
    downloadEmployeeListPDF: (organizationId, status, locationId) => `/api/organization/getEmployeeListPDF?organization_id=${organizationId}&status=${status}&location_id=${locationId}`,
    fetchNotificationCount: (userId) => `/api/notifications/count?user_id=${userId}`,
    fetchUserNotifications: (userId) => `/api/notifications/getNotifications?userId=${userId}`,
    markNotificationsAsRead: "/api/notifications/mark-read",
    updateEmployeeProfile: (userId) => `/api/organization/updateEmployeeDetails?userId=${userId}`,
    fetchEmployeeDashboard: (userId, year, month) => `/api/organization/getDashboardDetailsByEmployeeId?userId=${userId}&year=${year}&month=${month}`,
    fetchTasksByEmployeeId: "/api/task/getAllTasksByEmployeeId",
    updateEmployeeTaskStatus: "/api/task/updateTaskStatusByEmployee",
    uploadAttachmentToTask: (taskId) => `/api/task/attachmentUpload/${taskId}`,
    getTeamLeadsAndManagers: (orgId) => `/api/project/getAllTeamLeadOrManager?organization_id=${orgId}&is_manager=true&is_team_lead=true`,
    uploadUsersByCsv: '/api/organization/userSignupByCsv',
    updateEmployeePersonalContact: '/api/hr/updatePersonalContactTab',
    deleteProjectById: (projectId) => `/api/project/deleteProject/${projectId}`,
    getAllEmploymentTypes: (orgId) => `/api/hr/getAllEmploymentTypes/${orgId}`,
    getPayrollSettingsByEmployeeId: (userId) => `/api/employeePayrollSettings/getPayrollSettingsById?employeePersonalId=${userId}`,
    updatePayrollSettings: "/api/employeePayrollSettings/updatePayrollSettings",
    createPayrollSettings: "/api/employeePayrollSettings/createPayrollSettings",
    updateEmployeeFinanceAndStatutory: "/api/hr/updateEmployeeFinanceAndStatutory",
    getAllEmployeeDocumentsByUserId: (userId) => `/api/hr/getAllEmployeeDocuments/${userId}`,
    uploadEmployeeFiles: "/api/hr/documentsUpload",
    deleteEmployeeDocument: "/api/hr/deleteEmployeeDocument",
    getAllLeavePoliciesByOrganizationId: (orgId) => `/api/hr/getAllLeavePolicies/${orgId}`,
    getAllShiftTypesByOrganizationId: (orgId) => `/api/hr/getAllShiftTypes/${orgId}`,
    getAllAttendanceSourcesByOrganizationId: (orgId) => `/api/hr/getAllAttendanceSources/${orgId}`,
    getAllHolidayPoliciesByOrganizationId: (orgId) => `/api/hr/getAllHolidayPolicies/${orgId}`,
    updateEmployeePolicyAssignment: "/api/hr/updateEmployeePolicyAssignment",
    fetchExitRehireDetails: (userId) => `/api/hr/getEmployeeExitRehireDetails/${userId}`,
    getIncomeTaxForm: (empId, financialYear) => `/api/income-tax/get-form12A?employeePersonalId=${empId}&financialYear=${financialYear}`,
    calculateIncomeTax: "/api/income-tax/calculate-tax",
    getTaxSummaryByFinancialYear: (empId, financialYear) => {
        if (!financialYear) {
            return `/api/income-tax/tax-summary?financialYear=${financialYear}`;
        }
        return `/api/income-tax/tax-summary?employeePersonalId=${empId}&financialYear=${financialYear}`;
    },
    getEmployeeTaxDeclaration: (empId, financialYear) => `/api/income-tax/getDeclarationById?employeePersonalId=${empId}&financialYear=${financialYear}`,
    getTaxOptions: "/api/income-tax/tax-options",
    declareEmployeeInvestments: "/api/income-tax/declare-investments",
    uploadInvestmentProof: "/api/income-tax/upload-proof",
    uploadForm: "/api/income-tax/upload-form12A",
    submitTaxRegimeChangeRequest: "/api/income-tax/submit-regime-change-request",
    getEmployeePayslipByDateRange: (
        startMonth,
        startYear,
        endMonth,
        endYear
    ) => `/api/batchPayroll/getEmployeePayslip?startMonth=${startMonth}&startYear=${startYear}&endMonth=${endMonth}&endYear=${endYear}`,
    fetchEmployeeReimbursements: (empId) => `/api/reimbursements/getReimbursementByemployeeId?employeePersonalId=${empId}`,
    createEmployeeReimbursement: "/api/reimbursements/createReimbursement",
    getDailyAttendanceOverview: (orgId) => `/api/organization/getTodayAttendanceOverview/${orgId}`,
    getHRAttendanceEmployeesByDateAndOrgId: (date, orgId) => `/api/organization/getAllEmployeesForHrAttendence?Date=${date}&organization_id=${orgId}`,
    getDayWiseAttendancePDF: (params) => `/api/organization/getDayWiseAttendancePDF`,
    getDayWiseAttendanceExcel: (params) => `/api/organization/getDayWiseAttendanceExcel`,
    downloadMonthlyAttendancePDF: (params) => '/api/organization/getMonthlyAttendancePDF',
    downloadMonthlyAttendanceExcel: (params) => '/api/organization/getMonthlyAttendanceExcel',
    getEmployeeMonthlyAttendanceOverviewForHR: (params) => `/api/organization/getAttendanceOverviewByEmployeeIdByMonthForHr`,
    downloadEmployeeDailyAttendancePDF: (params) => `/api/organization/getEmployeeDailyAttendancePDF`,
    downloadEmployeeDailyAttendanceExcel: (params) => `/api/organization/getEmployeeDailyAttendanceExcel`,
    getAllLeaveRequestsByOrganizationId: (params) => `/api/organization/getAllLeaveRequestsByOrgId`,
    updateEmployeeLeaveBalance: "/api/organization/updateLeaveBalance",
    getAllLeaveBalancesByOrganizationId: (orgId) => `/api/organization/getAllLeaveBalancesByOrgId?organization_id=${orgId}`,
    getAllLeaveTypesByEmployeeId: (empId) => `/api/organization/getAllLeaveTypesByEmpId?user_id=${empId}`,
    getAllLeaveHistoryByOrganizationId: `/api/organization/getAllLeaveHistoryByOrgId`,
    downloadLeaveHistoryPDF: (params) => `/api/organization/getLeaveHistoryPDF`,
    downloadLeaveHistoryExcel: (params) => `/api/organization/getLeaveHistoryExcel`,
    updateHolidayById: (holidayId) => `/api/organization/updateHoliday/${holidayId}`,
    createHoliday: "/api/organization/createHoliday",
    deleteHolidayById: (holidayId) => `/api/organization/deleteHoliday/${holidayId}`,
    updateLeaveTypeById: (leaveTypeId) => `/api/organization/updateLeaveType/${leaveTypeId}`,
    createLeaveType: "/api/organization/createLeaveType",
    deleteLeaveTypeById: (leaveTypeId) => `/api/organization/deleteLeaveType/${leaveTypeId}`,
    getPayrollReportDashboard: "/api/payrollReportTypes/dashboard",
    getRecentActivities: (page, limit) => `/api/recentActivity/getAllActivities?page=${page}&limit=${limit}`,
    getPayrollsByHrId: (hrId) => `/api/payrollCompensation/getAllPayrollsByHrId?hr_id=${hrId}`,
    getPayrollCompensationByEmployeeId: (empId) => `/api/payrollCompensation/getPayrollCompensationById?employeePersonalId=${empId}`,
    createPayrollCompensation: "/api/payrollCompensation/createPayrollCompensation",
    calculatePayrollAllowances: "/api/payrollCompensation/calculateAllowances",
    previewPayrollCompensation: "/api/payrollCompensation/previewPayrollCompensation",
    getNotes: "/api/notes/getNotes",
    updateNote: "/api/notes/updateNote",
    verifyIncomeTaxProof: "/api/income-tax/admin/verify-proof",
    getReimbursementsByHrId: (hrId) => `/api/reimbursements/getReimbursements?hr_id=${hrId}`,
    createReimbursement: "/api/reimbursements/createReimbursement",
    deleteReimbursementById: (id) => `/api/reimbursements/deleteReimbursementById?id=${id}`,
    getUpcomingPayrollMonths: (includeNextFY = true) => `/api/reimbursements/getUpcomingPayrollMonths?includeNextFY=${includeNextFY}`,
    updateReimbursementById: "/api/reimbursements/updateReimbursementById",
    getBatchOverview: (year, month) => `/api/batchPayroll/getBatchOverview?year=${year}&month=${month}`,
    updateBatchPayrollById: "/api/batchPayroll/updateBatchPayrollByid",
    createBatchPayroll: "/api/batchPayroll/createBatchPayroll",
    getPayrollMonthsDropdown: "/api/batchPayroll/getPayrollMonthsDropdown",
    getLeaveEncasementByHR: "/api/reimbursements/getLeaveEncashmentByHR",
    getLeaveEncasement: "/api/reimbursements/getLeaveEncashment",
    updateLeaveEncasement: "/api/reimbursements/updateLeaveEncashment",
    getEmployeeBankingAndStatutoryDetails: "/api/reimbursements/getEmployeeBankingAndStatutoryDetails",
    getBatchPayrollSummary: (year, month) => `/api/batchPayroll/getBatchPayrollSummary?year=${year}&month=${month}`,
    updateBatchPayrollLock: "/api/batchPayroll/updateBatchPayrollLock",
    getBatchPayrollById: (id) => `/api/batchPayroll/getBatchPayrollByid?id=${id}`,
    disbursePayrollPayouts: "/api/payrollPayment/disbursePayrollPayouts",
    updateBatchPayrollLockAndFinalize: "/api/batchPayroll/updateBatchPayrollLockandfinalized",
    getTransactionDetails: (queryString) => {
        return queryString
            ? `/api/payrollPayment/getTransactionDetails?${queryString}`
            : "/api/payrollPayment/getTransactionDetails";
    },
    getAllDepartments: "/api/reimbursements/getAllDepartments",
    getPayrollReportByType: (reportType) => `/api/payrollReportTypes/${reportType}`,
    getPayrollReportTypesDropdown: "/api/payrollReportTypes/dropdown",
    getPayrollCompensationConstants: "/api/payrollCompensation/constants",
    updatePayrollCompensationConstants: "/api/payrollCompensation/constants/update",
    deletePayrollCompensationConstants: "/api/payrollCompensation/constants/delete",
    getAdminTaxBreakdowns: "/api/income-tax/admin/tax-breakdowns",
    manageTaxBreakdown: "/api/income-tax/admin/manage-tax-breakdown",
    deleteTaxBreakdownById: (id) => `/api/income-tax/admin/delete-tax-breakdown/${id}`,
    resendEmailVerification: "/api/auth/resend-email-verification",
    getGoalsGroupedByTitle: "/api/performanceHr/getGoalsGroupedByTitle",
    fetchAllTasks: (params) => {
        const { search, project_id, epic_id, user_story_id, work_type, priority, status, user_role, user_id, page, limit, assignee } = params;
        const query = new URLSearchParams({
            search: search || "",
            project_id: project_id || "",
            epic_id: epic_id || "",
            user_story_id: user_story_id || "",
            work_type: work_type || "",
            priority: priority || "",
            status: status || "",
            user_role: user_role || "", // Matches backend destructuring
            user_id: user_id || "",     // Matches backend destructuring
            page: page || 1,
            limit: limit || 10,
            assignee: assignee || ""
        }).toString();

        return `/api/task/getAllTasks?${query}`;
    },
    fetchTaskById: (id) => `/api/task/getTaskById/${id}`,
    getEmployeeTasks: (empId) => `/api/task/getTasksByEmployee?employeeId=${empId}`,
    uploadTaskAttachments: "/api/task/upload-attachments",
    createEmployeeExit: "/api/hr/initiateEmployeeExit",
    getEmployeeExitAndRehireDetails: (empId) => `/api/hr/getEmployeeExitRehireDetails/${empId}`,
    reactivateEmployee: "/api/hr/rehireEmployee",
    
    // Dashboard counts
    getManagerDashboardCounts: "/api/dashboard/getManagerDashboardStats",
    getHrDashboardCounts: "/api/dashboard/getHrDashboardStats",
    getTeamLeadDashboardCounts: "/api/dashboard/getTeamLeadDashboardStats",
    getEmployeeDashboardCounts: "/api/dashboard/getEmployeeDashboardStats",

    // Story Management
    createUserStory: "/api/user-stories/create",
    fetchStories: "/api/user-stories/all",
    fetchUserStoryDetails: (id) => `/api/user-stories/${id}`,
    updateUserStoryById: (id) => `/api/user-stories/${id}`,
    deleteUserStoryById: (id) => `/api/user-stories/${id}`,

    // leave Management
    fetchAllLeaveRequests: (params) => {
        const { organization_id, search, status, month, year, page, limit } = params;

        const query = new URLSearchParams({
            organization_id: organization_id || "",
            search: search || "null",
            status: status || "PENDING",
            month: month || "null",
            year: year || "null",
            page: page || "null",
            limit: limit || "null"
        }).toString();

        return `/api/leaveManagement/requests?${query}`;
    },
    fetchLeaveRequestsByTeamLead: (teamLeadId, params = {}) => {
        const { search, status, month, year, page, limit } = params;

        const query = new URLSearchParams({
            teamLeadId: teamLeadId,
            search: search || "null",
            status: status || "PENDING",
            month: month || "null",
            year: year || "null",
            page: page || "null",
            limit: limit || "null"
        }).toString();

        return `/api/leaveManagement/team-lead/leave-requests?${query}`;
    },



};